import AddAmenitiesFormField from '../../../PostingPath/AddAmenities/AddAmenitiesFormField';
import AddEditPhoneNumber from '../../../PostingPath/AddEditPhoneNumber';
import AddressFormField from '../../../PostingPath/AddressFormField';
import AllowContactByPhoneFormField from '../../../PostingPath/AllowContactByPhoneFormField';
import AmenitiesInteriorFormField from '../../../PostingPath/AmenitiesInteriorFormField';
import AmenitiesPropertyFormField from '../../../PostingPath/AmenitiesPropertyFormField';
import AcceptZillowApplicationsFormField from '../../../PostingPath/ApplicationsFormField/AcceptZillowApplicationsFormField';
import BathroomsFormField from '../../../PostingPath/BathroomsFormField';
import BedroomsFormField from '../../../PostingPath/BedroomsFormField';
import CurrentPetsFormField from '../../../PostingPath/CurrentPetsFormField';
import DateAvailableFormField from '../../../PostingPath/DateAvailableFormField';
import EmailFormField from '../../../PostingPath/EmailFormField';
import FinancialExpectationsFormField from '../../../PostingPath/FinancialExpectationsFormField';
import ForRentByFieldSet from '../../../PostingPath/ForRentByFieldSet';
import GenderPreferenceFormField from '../../../PostingPath/GenderPreferenceFormField';
import HideAddressFormField from '../../../PostingPath/HideAddressFormField';
import LeaseDurationFormField from '../../../PostingPath/LeaseDurationFormField';
import LeaseTermsFormField from '../../../PostingPath/LeaseTermsFormField';
import MonthlyRentFormField from '../../../PostingPath/MonthlyRentFormField';
import NameFormField from '../../../PostingPath/NameFormField';
import PetPolicyFormField from '../../../PostingPath/PetPolicyFormField';
import PetsAllowedFormField from '../../../PostingPath/PetsAllowedFormField';
import PropertyDescriptionFormField from '../../../PostingPath/PropertyDescriptionFormField';
import PropertyTypeFormField from '../../../PostingPath/PropertyTypeFormField';
import RentersInsuranceFormField from '../../../PostingPath/RentersInsuranceFormField';
import RoomForRentByFormField from '../../../PostingPath/RoomForRentByFormField';
import RoommateCountFormField from '../../../PostingPath/RoommateCountFormField';
import RoommateDescriptionFormField from '../../../PostingPath/RoommateDescriptionFormField';
import RoomSquareFootageFormField from '../../../PostingPath/RoomSquareFootageFormField';
import RoomUtilitiesFormField from '../../../PostingPath/RoomUtilitiesFormField';
import SecurityDepositFormField from '../../../PostingPath/SecurityDepositFormField';
import SpecialOfferFormField from '../../../PostingPath/SpecialOffers/SpecialOfferFormField';
import SquareFootageFormField from '../../../PostingPath/SquareFootageFormField';

export const SF_MODAL_COMPONENTS = {
  AddressFormField: {
    title: 'Address',
    component: AddressFormField,
    componentKey: 'AddressFormField',
  },
  BathroomsFormField: {
    title: 'Bathrooms',
    component: BathroomsFormField,
    componentKey: 'BathroomsFormField',
  },
  BedroomsFormField: {
    title: 'Bedrooms',
    component: BedroomsFormField,
    componentKey: 'BedroomsFormField',
  },
  HideAddressFormField: {
    title: 'Hide property address',
    component: HideAddressFormField,
    componentKey: 'HideAddressFormField',
  },
  PropertyDescriptionFormField: {
    title: 'Property description',
    component: PropertyDescriptionFormField,
    componentKey: 'PropertyDescriptionFormField',
  },
  PropertyTypeFormField: {
    title: 'Property type',
    component: PropertyTypeFormField,
    componentKey: 'PropertyTypeFormField',
  },
  RoomSquareFootageFormField: {
    title: 'Room square footage',
    component: RoomSquareFootageFormField,
    componentKey: 'RoomSquareFootageFormField',
  },
  SquareFootageFormField: {
    title: 'Square footage',
    component: SquareFootageFormField,
    componentKey: 'SquareFootageFormField',
  },
  MonthlyRentFormField: {
    title: 'Monthly rent',
    component: MonthlyRentFormField,
    componentKey: 'MonthlyRentFormField',
  },
  BaseRentFormField: {
    title: 'Base rent',
    component: MonthlyRentFormField,
    componentKey: 'BaseRentFormField',
  },
  SecurityDepositFormField: {
    title: 'Security deposit',
    component: SecurityDepositFormField,
    componentKey: 'SecurityDepositFormField',
  },
  DateAvailableFormField: {
    title: 'Date available',
    component: DateAvailableFormField,
    componentKey: 'DateAvailableFormField',
  },
  RoomUtilitiesFormField: {
    title: 'Utilities',
    component: RoomUtilitiesFormField,
    componentKey: 'RoomUtilitiesFormField',
  },
  PetPolicyFormField: {
    title: 'Pets',
    component: PetPolicyFormField,
    componentKey: 'PetPolicyFormField',
  },
  RoommateCountFormField: {
    title: 'Roommate count',
    component: RoommateCountFormField,
    componentKey: 'RoommateCountFormField',
  },
  SpecialOffersFormField: {
    title: 'Special offers',
    component: SpecialOfferFormField,
    componentKey: 'SpecialOffersFormField',
  },
  RoommateDescriptionFormField: {
    title: 'Roommates description',
    component: RoommateDescriptionFormField,
    componentKey: 'RoommateDescriptionFormField',
  },
  GenderPreferenceFormField: {
    title: 'Roommates description',
    component: GenderPreferenceFormField,
    componentKey: 'GenderPreferenceFormField',
  },
  RoomCurrentPetsFormSectionContainer: {
    title: 'Pets',
    component: CurrentPetsFormField,
    componentKey: 'RoomCurrentPetsFormSectionContainer',
  },
  AmenitiesInteriorFormField: {
    title: 'Interior amenities',
    component: AmenitiesInteriorFormField,
    componentKey: 'AmenitiesInteriorFormField',
  },
  AmenitiesPropertyFormField: {
    title: 'Property amenities',
    component: AmenitiesPropertyFormField,
    componentKey: 'AmenitiesPropertyFormField',
  },
  AmenitiesAdditionalFormField: {
    title: 'Additional amenities',
    component: AddAmenitiesFormField,
    componentKey: 'AmenitiesAdditionalFormField',
  },
  FinancialExpectationsFormField: {
    title: 'Financial expectations',
    component: FinancialExpectationsFormField,
    componentKey: 'FinancialExpectationsFormField',
  },
  PetsAllowedFormField: {
    title: 'Pets',
    component: PetsAllowedFormField,
    componentKey: 'PetsAllowedFormField',
  },
  ForRentByFieldSet: {
    title: 'Listed by',
    component: ForRentByFieldSet,
    componentKey: 'ForRentByFieldSet',
  },
  RoomForRentByFormField: {
    title: 'Listed by',
    component: RoomForRentByFormField,
    componentKey: 'RoomForRentByFormField',
  },
  LeaseDurationFormField: {
    title: 'Lease duration',
    component: LeaseDurationFormField,
    componentKey: 'LeaseDurationFormField',
  },
  LeaseTermsFormField: {
    title: 'Lease terms',
    component: LeaseTermsFormField,
    componentKey: 'LeaseTermsFormField',
  },
  RentersInsuranceFormField: {
    title: 'Renters insurance',
    component: RentersInsuranceFormField,
    componentKey: 'RentersInsuranceFormField',
  },
  NameFormField: {
    title: 'Name',
    component: NameFormField,
    componentKey: 'NameFormField',
  },
  AllowContactByPhoneFormField: {
    title: 'Allow renters to contact you by phone',
    component: AllowContactByPhoneFormField,
    componentKey: 'AllowContactByPhoneFormField',
  },
  AcceptZillowApplicationsFormField: {
    title: 'Zillow applications',
    component: AcceptZillowApplicationsFormField,
    componentKey: 'AcceptZillowApplicationsFormField',
  },
  EmailFormField: {
    title: 'Email',
    component: EmailFormField,
    componentKey: 'EmailFormField',
  },
  PhoneNumberFormField: {
    title: 'Phone number',
    component: AddEditPhoneNumber,
    componentKey: 'PhoneNumberFormField',
  },
};
